/**
 * Get a value from localstorage, or a default
 * @param {string} key - The key for the value in localstorage
 * @param {*} defaultValue - The value to return if there is no value
 */
export const getLocalOrDefault = (key, defaultValue) => {
  const localValue = window.localStorage.getItem(key);
  if (localValue === null) return defaultValue;
  try {
    return JSON.parse(localValue || defaultValue);
  } catch (e) {
    return localValue;
  }
};

/**
 * Set a value in localstorage
 * @param {string} key - The key for the value in localstorage
 * @param {*} value - The value to store
 */
export const setLocal = (key, value) => {
  if (typeof value !== 'string') {
    value = JSON.stringify(value);
  }
  window.localStorage.setItem(key, value);
};

/**
 * Check if there is a localstorage value for a key
 * @param {string} key - The key for the value in localstorage
 */
export const hasLocal = (key) => {
  const localValue = window.localStorage.getItem(key);
  return localValue !== null;
};

/**
 * Clear out the value for a key in localstorage
 * @param {string} key - The key for the value in localstorage
 */
export const clearLocal = (key) => {
  window.localStorage.removeItem(key);
};

/**
 * Keys to use for storing and retrieving data in localStorage
 * These values must be unique to avoid overwriting each other, and should not
 * be changed without considering how it would affect current user data
 */
export const storageKeys = {
  currentUser: 'sb-user',
  armCampaignTableView: 'sb-arm-campaign-table-view',
  navSidebarHidden: 'sb-nav-sidebar-hidden',
  armCampaignTemplateView: 'sb-arm-campaign-template-view',
  udmCheckListCardHidden: 'sb-udm-check-list-card-hidden',
  udmRiskRatingProtocol: 'sb-udm-risk-rating-protocol',
  udmGlobalStatsProtocol: 'sb-udm-global-stats-protocol',
  udmOpenAccessProtocol: 'sb-udm-open-access-protocol',
  udmExcessiveAccessProtocol: 'sb-udm-excessive-access-protocol',
  udmNonstandardAccessProtocol: 'sb-udm-nonstandard-access-protocol',
  udmSecurityIssuesProtocol: 'sb-udm-security-issues-protocol',
  udmSensitiveDataOverviewProtocol: 'sb-udm-sensitive-data-overview',
  udmStaleDataOverviewProtocol: 'sb-udm-stale-data-overview',
  udmOwnershipProtocol: 'sb-udm-ownership-protocol',
};
